import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './style/style.scss'
import '@splidejs/splide/dist/css/themes/splide-skyblue.min.css'

ReactDOM.render(<App />, document.getElementById('root'))
